<template lang="pug">
box
  page-title(slot="page-title", title="Cadastros")
    filter-button(
      slot="action",
      @click="$router.push('/app/cadastros/filtrar')",
      :filtered="filtered"
    )
  list-manager.scrollable(
    slot="content",
    :errors="errors",
    :pages="pages",
    :page="page",
    :loading="loading",
    :next="nextPage",
    :prev="prevPage",
    :count="list.length"
  )
    router-view
    .container.grid-lg(v-if="list.length > 0")
      .columns
        .column.col-6.col-sm-12.my-2(
          v-for="cadastro in list",
          :key="cadastro.id"
        )
          row(:cadastro="cadastro")
</template>

<script>
import listMixin, { defaultStoreImports } from "@/mixins/list";
import Row from "./Row";

export default {
  vuex: { cadastros: defaultStoreImports },
  components: { Row },
  mixins: [listMixin],
};
</script>
